export default __webpack_public_path__ + "static/media/logo_kiddies.52a8b9f7.png";